<template>
	<div class="chargingRecord">
		<div class="itemTitleBox disStart">
			<span class="title" :class="{active:active==0}" @click="changeList(0)">充值记录</span>
			<span class="linBox"></span>
			<span class="title" :class="{active:active==2}" @click="changeList(2)">卡充值记录</span>
			<span class="linBox"></span>
			<span class="title" :class="{active:active==1}" @click="changeList(1)">提现记录</span>
			
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="disBetween searchLeft">
					<div class="myinputBox" v-if="active!=2">
						<el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称">
						</el-input>
					</div>
					<div class="myinputBox" v-if="active==2">
						<el-input clearable v-model="searchObj.cardNumber" placeholder="请输入卡号">
						</el-input>
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.userName" placeholder="请输入用户名">
						</el-input>
					</div>
					<div class="myinputBox" v-if="active==0 &&  !($serviceProviderId)">
						<el-select clearable v-model="searchObj.serviceProviderId" slot="prepend" placeholder="请选择运营商">
							<el-option v-for="(item,inx) in serviceList" :key="inx" :label="item.serviceProviderName"
								:value="item.serviceProviderId"></el-option>
						</el-select>
					</div>
					<div class="myinputBox" v-if="active==0">
						<el-select clearable v-model="searchObj.rechargeType" slot="prepend" placeholder="请选择充值类型">
							<el-option v-for="(item,inx) in chargeTpyeList" :key="inx" :label="item.text"
								:value="item.value"></el-option>
						</el-select>
					</div>
					<div class="myinputBox" v-if="active==1">
						<el-select clearable v-model="searchObj.withdrawalFlag" slot="prepend" placeholder="请选择审核状态">
							<el-option v-for="(item,inx) in withdrawalFlagList" :key="inx" :label="item.text"
								:value="item.value"></el-option>
						</el-select>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
							placeholder="开始时间">
						</el-date-picker>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
							placeholder="结束时间">
						</el-date-picker>
						<!-- <el-date-picker v-model="searchObj.searchData" type="daterange" range-separator="~"
							value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker> -->
					</div>
					<el-button type="success" @click="toSearch">查询</el-button>
				</div>
				<el-button type="success" @click="exportData">导出</el-button>
			</div>

		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-loading="loading" v-if="active==0">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeTime" label="充值时间" width="180">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="userName" label="用户名">
							<template slot-scope="scope">
								<span>{{scope.row.loginId?((scope.row.loginId).slice(10)):""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeAmount" label="充值金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="extraCoinAmount" label="赠送金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="accountBalance" label="账户剩余充值金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="accountExtraBalance" label="账户剩余赠送券">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeType" label="充值类型">
							<template slot-scope="scope">
								<span>{{getName(scope.row.rechargeType,chargeTpyeList)}}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
			<div style="height: 100%;width: 100%;" v-loading="loading" v-if="active==1">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="withdrawalTime" label="提现时间" width="140">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="loginIdName" label="用户名">
							<!-- <template slot-scope="scope">
								<span>{{scope.row.loginId?((scope.row.loginId).slice(10)):""}}</span>
							</template> -->
						</el-table-column>
						<el-table-column prop="phone" label="联系方式" width="110">
						</el-table-column>
						<el-table-column prop="accountBalance" label="剩余充值金(元)" width="130">
						</el-table-column>
						<el-table-column prop="withdrawalAmount" label="提现金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="withdrawalCont" label="审核状态">
							<!-- <template slot-scope="scope">
								<span>{{scope.row.withdrawalName}}
									<span v-if="scope.row.withdrawalFlag==3">
										({{scope.row.auditReason}})
									</span>
								</span>
							</template> -->
						</el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="withdrawalReason" label="不通过理由">
						</el-table-column> -->
						<el-table-column show-overflow-tooltip prop="approvalTime" label="审核时间" width="140">
						</el-table-column>
						<el-table-column label="操作" width="70">
							<template slot-scope="scope">
								<el-button v-if=" scope.row.withdrawalFlag==1"
									type="text" size="small" @click="itemClick(scope.row,1)">审核</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
			<div style="height: 100%;width: 100%;" v-loading="loading" v-if="active==2">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeTime" label="充值时间" width="180">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="cardNumber" label="卡号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="userName" label="用户名">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeAmount" label="充值金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="extraCoinAmount" label="赠送金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="cardAccount" label="卡剩余充值金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="extraCardAccount" label="卡剩余赠送券">
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="提现审核" center class="mydialog" :visible.sync="dialogVisible3" width="60%">
			<el-form :model="diaObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox dialogBox3">
					<div class="contBox">
						<div class="itemBox3 disStart">
							<el-form-item class="lableBox" label="审核结果：" prop="withdrawalFlag">
								<div class="myinputBox">
									<el-select clearable v-model="diaObj.withdrawalFlag" slot="prepend"
										placeholder="请选择审核结果">
										<el-option v-for="(item,inx) in examineList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="itemBox3 disStart" v-if="diaObj.withdrawalFlag==3">
							<el-form-item class="lableBox" label="审核说明：" prop="auditReason">
								<div class="myinputBox">
									<el-input clearable v-model="diaObj.auditReason" placeholder="请输入审核说明">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible3=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm1')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>

</template>

<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../../assets/js/common.js"
	var token = localStorage.getItem('token')
	export default {
		name: "chargingRecord",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				dialogVisible3: false,
				active: 0,
				tableData: [],
				communityList: [],
				operateStatusList: [{
						text: "未投用",
						value: 1
					},
					{
						text: "运营中",
						value: 2
					},
					{
						text: "已拆除",
						value: 3
					},
				],
				chargeTpyeList: [{
						text: "用户充值",
						value: 1
					},
					{
						text: "充电反币",
						value: 2
					},
					{
						text: "商城反币",
						value: 3
					}
				],
				loading: false,
				total: 0,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 8, //当前页个数
					userName: "", //用户名称
					searchData: [],
					communityId: "",
					serviceProviderId: "",
					cardNumber:"",
					rechargeType: null, //充值类型 1用户充值 2充电反币 3商城反币
					startTime: "", //开始时间
					endTime: "" //结束时间
				},
				restaurants: [],
				options: [],
				serviceList: [],
				diaObj: {
					withdrawalFlag: ""
				},
				withdrawalFlagList: [{
						text: "审核中",
						value: 1
					}, {
						text: "审核通过",
						value: 2
					},
					{
						text: "审核不通过",
						value: 3
					}
				],
				examineList: [{
						text: "通过",
						value: 2
					},
					{
						text: "不通过",
						value: 3
					}
				],
				rules: {
					withdrawalFlag: [{
						required: true,
						message: '请选择是否通过提现申请',
						trigger: 'change'
					}],
					auditReason: [{
						required: true,
						message: '请输入不通过提现理由',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			if(localStorage.getItem('mainUser')==1){
				this.$set(this.searchObj,"pageSize",8)
				this.$set(this.PageInfo,"pageSize",8)
			}else{
				this.$set(this.searchObj,"pageSize",10)
				this.$set(this.PageInfo,"pageSize",10)
			}
			// let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			// this.searchObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]
			this.$nextTick(() => {
				this.getData(this.active)
				this.selectParamConfigByCode()
			})
		},
		methods: {
			exportData() {
				if (this.active == 0) {
					let obj = {
						userName: this.searchObj.userName,
						rechargeType: this.searchObj.rechargeType,
						communityId: this.searchObj.communityId,
						startTime: this.searchObj.startTime, //开始时间
						endTime: this.searchObj.endTime, //结束时间
						serviceProviderId: this.searchObj.serviceProviderId,

					}
					this.$api.exportUserInfoAccountRecord(obj, "充值记录").then((res) => {
						if (res.returnCode == 200) {

						}
					})
				} else if (this.active == 1){
					let obj = {
						userName: this.searchObj.userName,
						startTime: timeObj.startTime, //开始时间
						endTime: timeObj.endTime //结束时间
					}
					this.$api.exportUserInfoAccountWithdrawalRecord(obj, "提现记录").then((res) => {
						if (res.returnCode == 200) {}
					})
				}else if (this.active == 2){
					
				}

			},
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let obj = {
							id: this.diaObj.withdrawalId,
							auditReason: this.diaObj.auditReason || "",
							withdrawalFlag: this.diaObj.withdrawalFlag,
						}
						this.$api.checkWithdrawalRecord(obj).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									message: '审核成功',
									type: 'success'
								});
								setTimeout(() => {
									that.dialogVisible3 = false
									that.getData(1)
								}, 500)
							}
						})
					} else {
						return false;
					}
				});

			},
			itemClick(item) {
				console.log(item)
				this.$set(this.diaObj, "withdrawalFlag", '')
				this.$set(this.diaObj, "withdrawalId", item.id)
				this.$nextTick(() => {
					this.dialogVisible3 = true
					// this.initMap()
					this.$refs.ruleForm1.clearValidate()
				})
			},
			getName(val, arr) {
				if (val) {
					let obj = arr.find((item) => {
						return val == item.value
					})
					return obj.text
				} else {
					return ""
				}
			},
			changeList(n) {
				this.active = n
				this.searchObj.pageNo = 1
				this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					this.getData(n)
				})

			},
			selectParamConfigByCode() {
				this.$api.listAllProvider({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "serviceList", res.obj || [])
					}
				})
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			changeSelect(n) {
				console.log(n)
				// this.$set(this.searchObj, "communitySiteId", "")
			},
			toSearch() {
				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.$nextTick(() => {
					this.getData(this.active)
				})
			},
			getData(n) {
				this.loading = true
				// console.log(this.searchObj,6565655)
				console.log(localStorage.getItem('serviceProviderId'))
				if (n == 0) {
					let obj = {
						pageNo: this.searchObj.pageNo, //当前页
						pageSize: this.searchObj.pageSize, //当前页个数
						userName: this.searchObj.userName, //用户名称
						communityId: this.searchObj.communityId, //社区
						communityName: this.searchObj.communityName, //社区
						serviceProviderId: this.searchObj.serviceProviderId, //运营商
						rechargeType: this.searchObj.rechargeType, //充值类型 1用户充值 2充电反币 3商城反币
						startTime: this.searchObj.startTime, //开始时间
						endTime: this.searchObj.endTime, //结束时间
					}
					
					console.log(obj)//这里获取列表时是带serviceProviderId(运营商ID)的，后台应该没有做处理，直接展示了信息
					this.$api.listUserInfoAccountRecord(obj).then((res) => {
						console.log(res,333333)
						if (res.returnCode == 200) {
							this.loading = false
							this.$set(this, "tableData", res.obj.list || [])
							this.$set(this.PageInfo, "total", res.obj.total || 0)
						}
					})
				} else if (n == 1) {
					let obj = {
						withdrawalFlag: this.searchObj.withdrawalFlag,
						communityName: this.searchObj.communityName, //社区
						pageNo: this.searchObj.pageNo, //当前页
						pageSize: this.searchObj.pageSize, //当前页个数
						loginId: this.searchObj.userName, //用户名称
						startTime: this.searchObj.startTime, //开始时间
						endTime: this.searchObj.endTime, //结束时间
					}
					this.$api.listUserInfoAccountWithdrawalRecord(obj).then((res) => {
						if (res.returnCode == 200) {
							this.loading = false
							for (let k of res.obj.list) {
								k.withdrawalName = this.getName(k.withdrawalFlag, this.withdrawalFlagList)
								k.loginIdName = (k.loginId).slice(10)
								k.withdrawalCont = this.getName(k.withdrawalFlag, this.withdrawalFlagList) + (k
									.withdrawalFlag == 3 ? '(' + k.auditReason + ')' : "")
							}
							this.$set(this, "tableData", res.obj.list || [])
							this.$set(this.PageInfo, "total", res.obj.total || 0)
						}
					})
				}else if (n == 2) {
					let obj = {
						cardNumber: this.searchObj.cardNumber, //当前页
						userName: this.searchObj.userName, //当前页
						pageNo: this.searchObj.pageNo, //当前页
						pageSize: this.searchObj.pageSize, //当前页个数
						startTime: this.searchObj.startTime, //开始时间
						endTime: this.searchObj.endTime, //结束时间
					}
					this.$api.listUserInfoCardRecord(obj).then((res) => {
						if (res.returnCode == 200) {
							this.loading = false
							this.$set(this, "tableData", res.obj.list || [])
							this.$set(this.PageInfo, "total", res.obj.total || 0)
						}
					})
				}

			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData(this.active)
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./chargingRecord.scss"
</style>